export const popups = {
  registerRequest: {
    title: 'Antrag auf Registrierung',
    description:
      'Füllen Sie den Fragebogen aus und wir werden Sie kontaktieren.',
    button: 'Hinterlassen Sie einen Antrag auf Registrierung',
    form: {
      noteLabel: 'Wie haben Sie über uns gelernt?',
      notePlaceholder: 'Wie haben Sie über uns gelernt?',
      checkboxExperience: 'Ich bin mit Erfahrung im Club',
      club: {
        nameLabel: 'Der Name des Clubs',
        namePlaceholder: 'Der Name des Clubs'
      }
    }
  },
  invite: {
    title: 'Alter bestätigen',
    description:
      'Sind Sie 18 Jahre alt? Bestätigen Sie Ihr Alter, um die Plattform zu nutzen.',
    confirm: 'Ja, ich bin 18'
  },
  deleteAccount: {
    title: 'Konto löschen?',
    subTitle: 'Es wird unmöglich sein, die Entfernung zu stornieren.',
    description:
      'Anstelle des Entfernens kann das Profil versteckt werden. Es wird niemandem außer Ihnen verfügbar sein, bis Sie sich entscheiden, es zu öffnen.'
  },
  exitFromProfile: {
    title: 'Abmelden?',
    description: 'Bestätigen Sie, dass Sie sich abmelden möchten.'
  },
  hideAccount: {
    title: 'Profil verbergen?',
    description:
      'Ihr Profil ist für niemanden außer Ihnen sichtbar, bis Sie es wieder öffnen. Dies verbirgt Ihr Konto vor Clubs und anderen Künstlern.'
  },
  mainPhoto: {
    title: 'Titelbild',
    description: 'Wählen Sie ein Titelbild für Ihren Lebenslauf'
  },
  updateVideo: {
    title: 'Video hochladen',
    description: 'Bitte warten Sie, bis das Video hochgeladen ist'
  },
  consumation: {
    title: 'Verbrauch',
    description:
      'Geben Sie die 5 beliebtesten Positionen von der Verbraucher ein, wie viel jede Position und jeder Prozentsatz des Preis -Leistungs -Verhältnisses an die Künstlerkosten.'
  },
  crazyMenu: {
    title: 'Verrücktes Menü',
    description:
      'Geben Sie die 5 beliebtesten Positionen aus dem verrückten Menü und den Kosten für jeden ein.'
  },
  warningOnCloseOnboarding: {
    title: 'Sind Sie sicher?',
    description:
      'Sind Sie sicher, dass Sie die Eingabe beenden möchten? Ihr Lebenslauf wird nicht veröffentlicht. Clubs können Ihnen keine Angebote senden. Sie können später fortfahren.'
  },
  foreignLanguage: {
    title: 'Sprachniveau'
  },
  createWorkItem: {
    title: 'Einladung bestätigen',
    titleRequest: 'Anfrage bestätigen',
    inviteDescription:
      'Diese Informationen sind behauptet. Sie können sie in einem Chat mit einer Künstlerin besprechen und ihre Einladung aktualisieren',
    requestDescription:
      'Diese Informationen sind behauptet. Sie können sie in einem Chat mit einem Club besprechen und die Anwendung aktualisieren',
    suggestVacancy: 'Bieten Sie dem Künstler eine freie Stelle an',
    selectVacancy: 'Zeigen Sie die offene Stelle von Interesse an',
    ticketCreditOption: 'Die Möglichkeit, ein Ticket zu leihen',
    ticketCreditRequired: 'Benötige ich eine Ticketkredite?'
  },
  clubWorkInteraction: {
    artistWorkAtClub: 'Der Künstler arbeitet in Ihrem Club.',
    setLastDay: {
      title: 'Letzten Arbeitstag festlegen?',
      setLastWorkDate:
        'Geben Sie das Datum des letzten Arbeitstages des Künstlers an',
      description:
        'Nachdem er das letzte Datum für den Künstler festgelegt hat, kann es nicht geändert werden. Nach dem festgelegten Datum wird der Künstler den Vertrag in Ihrem Club abschließen.'
    },
    artistArrival: {
      title: 'Die Anwesenheit des Künstlers bestätigen?',
      description: 'Sie bestätigen die Anwesenheit des Künstlers in Ihrem Club',
      information:
        'Die Arbeit beginnt ab dem Moment, in dem Sie die Anwesenheit des Künstlers am Arbeitsplatz bestätigen.'
    },
    workCancel: {
      title: 'Vertrag stornieren?',
      description: 'Sie bestätigen die Stornierung des Vertrags'
    },
    wantEndDate: {
      title: 'Künstler möchte Enddatum setzen.'
    },
    newEndDate: {
      title: 'Letzter Arbeitstag'
    }
  },
  artistWorkInteraction: {
    manageCurentContract: {
      pendingLastWorkDateRequest:
        'Ihr Antrag auf Abschluss des Vertrags wird geprüft.',
      workStartOnArtistArrivalConfirm:
        'Die Arbeit beginnt ab dem Moment, in dem der Club Ihre Anwesenheit am Arbeitsplatz bestätigt.',
      weCanRequestLastWorkDate:
        'Fordern Sie Ihr Vertragsende beim Club an.',
      clubSetLastWorkDate:
        'Der Club hat Ihr letztes Arbeitsdatum in diesem Club festgelegt.'
    }
  },
  changeProfile: {
    title: 'Meine Clubs'
  },
  confirmOnboardingCompletion: {
    title: 'Ihr Portfolio wird veröffentlicht',
    description: 'Jetzt können Clubs Sie zur Arbeit einladen'
  },
  videoUploading: {
    title: 'Video hochladen',
    description: 'Bitte warten Sie, bis das Video hochgeladen ist'
  },
  addWorkItem: {
    title: 'Arbeitsplatz',
    vacancyQuestion: 'Für welche freien Stellen haben Sie gearbeitet?',
    validationMessage:
      'Sie haben bereits festgestellt, dass Sie in der Gegenwart arbeiten.'
  },
  selectMainPhoto: {
    title: 'Hauptfoto',
    description: 'Wählen Sie ein Titelbild für Ihren Lebenslauf'
  },
  deleteWorkExperience: {
    title: 'Löschen?',
    description: 'Möchten Sie diese Berufserfahrung wirklich löschen?'
  }
};
